module.exports = __webpack_public_path__ + "static/img/xmgjkdhyhjj.4ef10277.jpg";